import { default as UserFormModalV2 } from "./UserFormModalV2";
export default UserFormModalV2;
